export default __webpack_public_path__ + "static/media/pos-kot.eb7fbe8e.webp";